import React from 'react';
import { ArrowRight, Landmark, Scale, LayoutGrid } from 'lucide-react';
import { JOBS, PAGE } from './copy';
import type { JobId } from './types';

const JOB_META: {
    id: JobId;
    icon: typeof Landmark;
}[] = [
    { id: 'name_exit', icon: Landmark },
    { id: 'clear_freeze', icon: Scale },
    { id: 'show_all', icon: LayoutGrid },
];

export function OffRampJobChooser({
    selected,
    onSelect,
    compact,
}: {
    selected: JobId | null;
    onSelect: (jobId: JobId) => void;
    /** When a job is already chosen, show a compact strip to switch. */
    compact?: boolean;
}) {
    if (compact && selected) {
        return (
            <div className="flex items-center gap-2 flex-wrap text-xs">
                <span className="text-muted-foreground">{PAGE.changeJob}:</span>
                {JOB_META.map(({ id }) => (
                    <button
                        key={id}
                        type="button"
                        onClick={() => onSelect(id)}
                        className={
                            selected === id
                                ? 'px-2.5 py-1 rounded-md bg-primary text-primary-foreground font-medium'
                                : 'px-2.5 py-1 rounded-md border border-border bg-card text-muted-foreground hover:text-foreground hover:border-primary/40'
                        }
                    >
                        {JOBS[id].title}
                    </button>
                ))}
            </div>
        );
    }

    return (
        <div className="space-y-3">
            <h2 className="text-sm font-semibold text-foreground">What do you need to do?</h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                {JOB_META.map(({ id, icon: Icon }) => {
                    const job = JOBS[id];
                    const active = selected === id;
                    return (
                        <button
                            key={id}
                            type="button"
                            onClick={() => onSelect(id)}
                            className={
                                active
                                    ? 'text-left rounded-lg border-2 border-primary bg-primary/5 p-4 space-y-2 transition-colors'
                                    : 'text-left rounded-lg border border-border bg-card p-4 space-y-2 hover:border-primary/50 hover:bg-secondary/30 transition-colors'
                            }
                        >
                            <div className="flex items-center gap-2">
                                <Icon className="w-4 h-4 text-primary" />
                                <span className="text-sm font-semibold text-foreground">{job.title}</span>
                            </div>
                            <p className="text-xs text-muted-foreground leading-relaxed">{job.blurb}</p>
                            <span className="inline-flex items-center gap-1 text-xs font-medium text-primary">
                                {job.primaryCta} <ArrowRight className="w-3 h-3" />
                            </span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
